import Web3 from 'web3'
import { Address, Wei, SmartContractAction } from '../../utils/types'
import { Pool as PoolAbi } from '../../abi/abi'
import { maxWithdrawSlippage } from '../../config'
import { PoolWithData, TokenWithData } from '../api-types'
import { div } from '../../logic/weis/wei-calculate'
import { extractErrorMessage } from '../../logic/errors/extract-error-message'
import { Pool } from '../../logic/pools/Pool'
import { Hash, TransactionAction } from '../../logic/transactions/transactions'
import { Dispatch } from 'react'
import { moreGas } from '../../logic/weis/wei-calculate'

export type WithdrawResult = {
  userShareExit: Wei
  amounts: Map<TokenWithData, Wei>
  pool: Pool
  transactionHash: Hash
}

export class ExitApi {
  // @ts-ignore
  contract = new this.web3.eth.Contract(PoolAbi, this.poolAddress)

  constructor(
    public web3: Web3,
    public account: Address,
    public chainId: number,
    public poolAddress: string
  ) {}

  async exit(
    pool: PoolWithData,
    tokens: TokenWithData[],
    exitAmountWei: Wei,
    amounts: Map<TokenWithData, Wei>,
    dispatch: Dispatch<TransactionAction>
  ) {
    let minAmountsOut: Wei[] = []
    for (const token of tokens) {
      const min = div(amounts.get(token)!, 1 + maxWithdrawSlippage, 'floor')
      minAmountsOut.push(min)
    }

    // exit
    let txHash: string | undefined = undefined
    const exitGas = await this.contract.methods
      .exitPool(exitAmountWei, minAmountsOut)
      .estimateGas({ from: this.account })

    try {
      const receipt = await this.contract.methods
        .exitPool(exitAmountWei, minAmountsOut)
        .send({
          from: this.account,
          gas: moreGas(exitGas, SmartContractAction.MULTI_ASSET_EXIT),
          maxPriorityFeePerGas: null,
          maxFeePerGas: null,
        })
        .once('transactionHash', (hash: any) => {
          dispatch({
            type: 'submit',
            tx: {
              nonce: -1,
              type: 'withdraw-multi',
              status: 'pending',
              chainId: this.chainId,
              account: this.account,
              submitted: {
                hash,
                speedUp: false,
                start: new Date().getTime(),
              },
              data: {
                amount: exitAmountWei,
                pool: pool,
              },
              withdrawal: { amounts, pool: pool },
            },
          })

          txHash = hash
        })
      dispatch({
        type: 'complete',
        hash: txHash,
      })
      // TODO : Use the exact result for Postview
      return {
        userShareExit: exitAmountWei,
        amounts,
        pool: pool,
        transactionHash: txHash!,
      }
    } catch (error: any) {
      dispatch({
        type: 'fail',
        hash: txHash,
      })
      throw error
      }

  }

  async viewMultiAssetExitShare(amount: Wei): Promise<Wei[]> {
    return await this.contract.methods
      .getExitPool(amount)
      .call({ from: this.account })
  }
}
